import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { toast } from 'react-toastify';
import api from '../../../services/API';
import InputMask from 'react-input-mask';
import validarCpf from '../../../utils/validarCpf';

const PERMISSOES = {
  0: 'ADMINISTRADOR',
  1: 'SMART',
  2: 'AUDITOR',
  3: 'COORDENADOR',
  4: 'RELATORIO_ANALYTICS',
};

export default function CadastrarAdministrador() {
  const [enviando, setEnviando] = useState(false);
  const [cpf, setCpf] = useState('');
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [permissao, setPermissao] = useState('0');

  const cadastrarAdministrador = async (e) => {
    e.preventDefault();
    if (!nome) {
      toast.error('Nome obrigatório', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 10000,
      });
      return;
    }
    if (!cpf) {
      toast.error('CPF obrigatório', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 10000,
      });
      return;
    }
    if (!email) {
      toast.error('Email obrigatório', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 10000,
      });
      return;
    }
    if (!senha) {
      toast.error('Senha obrigatório', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 10000,
      });
      return;
    }

    let cpfFormatado = cpf.replace(/[^\d]/g, '');

    setEnviando(true);
    const permissaoNumero = Number(permissao);
    const resultado = await api.post('/api/usuarios', {
      nome,
      email,
      cpf: cpfFormatado,
      senha,
      permissao: permissaoNumero,
      permissaoNome: PERMISSOES[permissaoNumero],
    });

    if (resultado) {
      toast.success('Administrador cadastrado com sucesso', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 10000,
      });
      resetForm();
    }
    setEnviando(false);
  };

  const resetForm = () => {
    setCpf('');
    setNome('');
    setEmail('');
    setSenha('');
    setPermissao('0');
  };

  const buscarCpf = async (cpf) => {
    cpf = cpf.replace(/[^\d]/g, '');
    if (!cpf) return;
    const filtros = {
      cpf,
    };
    try {
      const resultado = await api.get(
        `/api/parceiros?filtros=${JSON.stringify(filtros)}`
      );
      if (resultado && resultado.data.usuarios && resultado.data.usuarios.length > 0) {
        toast.error('Usuário já cadastrado', {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 10000,
        });
        setCpf('');
      }
    } catch (error) {
      console.error('Erro ao buscar CPF:', error);
    }
  };

  const validarBuscarCpf = (e) => {
    const cpf = e.target.value;
    if (!cpf) return;
    if (!validarCpf(cpf)) {
      toast.error('CPF não é válido', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 10000,
      });
      setCpf('');
    } else {
      buscarCpf(cpf);
    }
  };

  return (
    <Container fluid>
      <div>
        <h4 className="pt-3 pb-3 f-black">Cadastrar Administrador</h4>
        <hr className="hr-loja mt-0 mb-5" />
      </div>
      <div className="d-flex flex-column align-items-center">
        <form className="form" onSubmit={cadastrarAdministrador}>
          <label htmlFor="nome">Nome</label>
          <input
            id="nome"
            name="nome"
            type="text"
            placeholder="Nome"
            onChange={(e) => setNome(e.target.value)}
            value={nome}
          ></input>
          <label htmlFor="cpf">CPF</label>
          <InputMask
            id="cpf"
            name="cpf"
            type="text"
            placeholder="CPF"
            mask="999.999.999-99"
            onChange={(e) => setCpf(e.target.value)}
            onBlur={validarBuscarCpf}
            value={cpf}
          />
          <label htmlFor="email">Email</label>
          <input
            id="email"
            name="email"
            type="text"
            placeholder="Email"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
          ></input>
          <label htmlFor="senha">Senha</label>
          <input
            id="senha"
            name="senha"
            type="password"
            placeholder="Senha"
            onChange={(e) => setSenha(e.target.value)}
            value={senha}
          ></input>
          <label htmlFor="permissao">Tipo de Usuário</label>
          <select
            id="permissao"
            name="permissao"
            value={permissao}
            onChange={(e) => setPermissao(e.target.value)}
            className="form-select"
          >
            <option value="0">Administrador</option>
            <option value="1">Smart</option>
            <option value="2">Auditor</option>
            <option value="3">Coordenador</option>
            <option value="4">Relatório Analytics</option>
          </select>
          {enviando ? (
            <button disabled className="btn-primario" type="submit">
              CADASTRANDO...
            </button>
          ) : (
            <button className="btn-primario" type="submit">
              CADASTRAR
            </button>
          )}
        </form>
      </div>
    </Container>
  );
}
